import React from 'react';
import { testimonials } from '../data/testimonials';
import { Stars } from './Stars';
export function Testimonials() {
  return <section className="bg-sage/25 px-4 py-9 sm:px-6 sm:py-12" data-id="element-230" data-mp="3krp59519wxqc">
      <div className="mx-auto max-w-6xl" data-id="element-231" data-mp="3fz5ndvvjzgfq">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-sage-dark sm:text-xs" data-id="element-232" data-mp="3fy2w3mubjbza">
          Conçu pour les orthophonistes
        </p>
        <h2 className="mt-1.5 text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-233" data-mp="36z964fbhtjup">
          Ce que disent les professionnels
        </h2>
        <div className="mt-2 flex flex-wrap items-center gap-2" data-id="element-234" data-mp="31yl4kzpn1km8">
          <Stars data-id="element-235" data-mp="2x1uquj1b313z" />
          <p className="font-display text-[10px] font-bold uppercase tracking-widest text-graphite/60" data-id="element-236" data-mp="2x1bk7yh3vz59">
            4,9/5 · À remplacer par données clients vérifiées
          </p>
        </div>
        <p className="mt-1 font-display text-[9px] font-bold uppercase tracking-[0.16em] text-graphite/45 sm:text-[10px]" data-id="element-237" data-mp="v859txg9hd2s">
          Témoignage d’exemple — à remplacer par un client vérifié
        </p>

        <ul className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-238" data-mp="h555tosv77qr">
          {testimonials.map(item => <li key={item.name} className="flex flex-col rounded-xl bg-white p-4 shadow-sm" data-id="element-239" data-mp="m6chhyy4or2p">
              <Stars data-id="element-240" data-mp="79bo7r0ago24" />
              <blockquote className="mt-2 flex-1 text-[13px] italic leading-snug text-graphite sm:text-sm" data-id="element-241" data-mp="7a4y30ujntoh">
                « {item.quote} »
              </blockquote>
              <footer className="mt-3" data-id="element-242" data-mp="zxr38djf76dg">
                <p className="font-display text-xs font-extrabold uppercase text-petrol" data-id="element-243" data-mp="14vj3buu7xysq">
                  {item.name}
                </p>
                <p className="text-[11px] text-graphite/60" data-id="element-244" data-mp="q5lav2p9amxq">{item.location}</p>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}